



























import Vue, { PropType } from 'vue';
import { Breadcrumb } from '@/models/breadcrumbs';

const DEFAULT_DIVIDER = '/';

export default Vue.extend({
  name: 'ABreadcrumbs',
  props: {
    items: { type: Array as PropType<Breadcrumb[]>, required: true },
    divider: { type: String, default: DEFAULT_DIVIDER },
  },
  methods: {
    getItemTextComponent(item: Breadcrumb) {
      if (item.to) {
        return 'router-link';
      }

      if (item.href) {
        return 'a';
      }

      return 'div';
    },
    isLastItem(index: number): boolean {
      return index === this.items.length - 1;
    },
    isDisabledItem(item: Breadcrumb, index: number): boolean {
      return item.disabled ?? this.isLastItem(index);
    },
  },
});
